module.exports = __webpack_public_path__ + "img/7.94d3b45d.jpg";